import React from 'react';
import '../css/spinner.css';
const Spinner = () => {
	return (
		<div className='spinner'>
			<div></div>
			<div></div>
			<div></div>
			<div></div>
		</div>
	);
};

export default Spinner;
